'use es6';

import promiseClient from '../adapters/promiseClient';
import { createStack } from '../index';
import hubapi from '../stacks/hubapi';
import { allowMissingPortalId } from '../middlewares/cookieAuth';
export default promiseClient(createStack(allowMissingPortalId, hubapi));